import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ISettingsVariant } from 'src/app/models/mastersuites/mastersuite';
import { AlertService } from 'src/app/services/alert.service';
import { MasterSuitesService } from 'src/app/services/mastersuites.service';
import { ProductsService } from 'src/app/services/products.service';

@Component({
    selector: 'app-master-suite-settings-varaint-dialog',
    templateUrl: './master-suite-settings-varaint-dialog.component.html',
    styleUrls: ['./master-suite-settings-varaint-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class MasterSuiteSettingsVaraintDialogComponent {
  settingsVariants!: ISettingsVariant[];
  isLoading = true;

  settingsVariantSelected?: ISettingsVariant;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private masterSuitesService: MasterSuitesService,
    private productsService: ProductsService,
    private router: Router,
    public dialogRef: MatDialogRef<MasterSuiteSettingsVaraintDialogComponent>,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    this.masterSuitesService.listSettingsVariants(this.dataDialog.masterSuiteId).subscribe({
      next: (res) => {
        this.settingsVariants = res.settingsVariants;
        if (!this.settingsVariants?.length) {
          this.dialogRef.close({
            settingsVariants: [],
          });
          return;
        }
        this.initializeVariantSelection();
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        this.dialogRef.close();
      },
    });
  }

  initializeVariantSelection() {
    if (this.settingsVariants.length === 1) {
      this.settingsVariantSelected = this.settingsVariants[0];
    }
    if (this.dataDialog.settingsVariantId) {
      this.settingsVariantSelected = this.settingsVariants.find(
        (en) => en.id === this.dataDialog.settingsVariantId,
      );
    }
  }

  openMasterSuite() {
    this.dialogRef.close();
    this.router.navigate([`mastersuites/${this.dataDialog.masterSuiteId}/update`]);
  }

  onSave() {
    this.productsService
      .applySettingsVariantOnProducts({
        productIds: this.dataDialog.productIds,
        settingsVariantId: this.settingsVariantSelected?.id || '',
        version: 0,
      })
      .subscribe({
        next: () => {
          this.alertService.successToast(
            `Settings Variant ${this.settingsVariantSelected?.name} applied!`,
          );
          this.dialogRef.close({
            settingsVariantSelected: this.settingsVariantSelected,
          });
        },
        error: () => {
          this.dialogRef.close();
        },
      });
  }
}
